import { useApplyEdition } from '@/pages/Apply/components/use-apply-edition';
import type { ApplyInvitesIdentity } from '@/types';
import { EventLabel } from '../components/EventLabel';
import { IdentityForm } from '../components/IdentityForm';
import { InviteNotFound } from '../components/InviteNotFound';

// app/(public)/${eventSlug}/invite/[handle]/identity/page.tsx + invitee-identity-form.tsx.
export default function Identity({
  segment,
  githubUsername,
  githubAvatarUrl,
  leaderHandle,
  notFoundReason,
}: ApplyInvitesIdentity) {
  const { eventSlug } = useApplyEdition();
  if (notFoundReason) {
    return (
      <>
        <InviteNotFound reason={notFoundReason} />
      </>
    );
  }

  return (
    <>
      <IdentityForm
        githubUsername={githubUsername}
        githubAvatarUrl={githubAvatarUrl}
        submitUrl={`/${eventSlug}/invite/${segment}/identity`}
        codeUrl={`/${eventSlug}/invite/${segment}/identity/code`}
        header={
          <>
            <p className="text-muted-foreground text-sm">
              Postulación a <EventLabel />
            </p>
            <h1 className="font-bold text-2xl uppercase tracking-wide sm:text-3xl">
              Hola, @{githubUsername}
            </h1>
            <p className="text-muted-foreground text-sm">
              Te estás sumando al equipo de @{leaderHandle}.
            </p>
          </>
        }
        conflictCopy={(role) =>
          role === 'leader'
            ? 'Tienes tu propia postulación en curso. Para unirte a este equipo, primero debes cancelarla. Si tienes compañeros, el liderazgo pasará al miembro más antiguo.'
            : 'Ya formas parte de otro equipo. Para unirte a este, primero debes salir del actual. Tu lugar anterior quedará libre.'
        }
        conflictAction={(role) =>
          role === 'leader' ? 'Cancelar y unirme aquí' : 'Salir y unirme aquí'
        }
      />
    </>
  );
}
